import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useModal } from '../../../hooks/use-modal';
import { AutomationRulesModal } from './automation-rules-modal';
import AcceptInviteModal from './client-accept-invite-modal';

export const AcceptInviteModalGuard = () => {
  const [marketPlaceName, setMarketplaceName] = useState('');

  const { isOpen: acceptInviteModalOpen, close: onCloseAcceptInviteModal, open: openAcceptInviteModal } = useModal();
  const { isOpen: isAutomationRulesModalOpen, close: closeAutomationRulesModal, open: openAutomationRulesModal } = useModal();
  const history = useHistory();

  useEffect(() => {
    if (window.location.pathname.includes('/accept')) {
      openAcceptInviteModal();
    }
  }, [openAcceptInviteModal]);

  const handleCloseAcceptInviteModal = useCallback(() => {
    onCloseAcceptInviteModal();
    history.push('/settings/fulfillment');
  }, [onCloseAcceptInviteModal, history]);

  const handleOpenAutomationRulesModal = (name) => {
    setMarketplaceName(name);
    openAutomationRulesModal();
  };

  return (
    <>
      {acceptInviteModalOpen && (
        <AcceptInviteModal onClose={handleCloseAcceptInviteModal} openAutomationRulesModal={handleOpenAutomationRulesModal} />
      )}
      {isAutomationRulesModalOpen && <AutomationRulesModal marketplaceName={marketPlaceName} onClose={closeAutomationRulesModal} />}
    </>
  );
};
